<template>
  <el-card shadow="never" class="sidebar-card checkin-rank">
    <template #header>
      <span class="card-title">签到排行</span>
    </template>
    <div v-loading="loading" class="checkin-rank-body">
      <div v-if="rankList.length" class="rank-avatar-grid">
        <el-tooltip
          v-for="row in rankList"
          :key="row.userId || row.rank"
          :content="avatarTitle(row)"
          placement="top"
          effect="dark"
          :show-after="200"
        >
          <button
            type="button"
            class="rank-avatar-btn"
            :class="rankClass(row.rank)"
            @click="openUserProfile(row.userId)"
          >
            <el-avatar :size="36" :src="row.avatar" class="rank-avatar" />
            <span v-if="row.rank >= 1 && row.rank <= 3" class="rank-badge">{{
              row.rank
            }}</span>
          </button>
        </el-tooltip>
      </div>
      <el-empty v-else-if="!loading" :image-size="60" description="暂无签到数据" />
    </div>
  </el-card>
</template>

<script>
import { getCheckinRank } from "@/api/checkin";

export default {
  name: "CheckinRank",
  data() {
    return {
      rankList: [],
      loading: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await getCheckinRank();
        if (res.data.code === 200) {
          this.rankList = res.data.data || [];
        }
      } catch (e) {
        console.error("加载签到排行失败:", e);
      } finally {
        this.loading = false;
      }
    },
    rankClass(rank) {
      if (rank === 1) return "is-gold";
      if (rank === 2) return "is-silver";
      if (rank === 3) return "is-bronze";
      return "";
    },
    avatarTitle(row) {
      const name = row.nickName || "用户";
      const days = row.days != null ? row.days : 0;
      return `${name} · ${days} 天`;
    },
    openUserProfile(userId) {
      if (userId == null || userId === "") return;
      const route = this.$router.resolve({ path: `/profile/${userId}` });
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.checkin-rank :deep(.el-card__header) {
  padding: 14px 16px;
}

.checkin-rank :deep(.el-card__body) {
  padding: 12px 12px 14px;
}

.checkin-rank-body {
  position: relative;
  min-height: 48px;
}

.rank-avatar-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px 8px;
  justify-items: center;
}

.rank-avatar-btn {
  position: relative;
  display: inline-flex;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  line-height: 0;
}

.rank-avatar {
  box-sizing: border-box;
  border: 2px solid transparent;
  background: var(--el-fill-color-light);
}

.rank-avatar-btn.is-gold .rank-avatar {
  border-color: #d4a012;
}

.rank-avatar-btn.is-silver .rank-avatar {
  border-color: #9ca3af;
}

.rank-avatar-btn.is-bronze .rank-avatar {
  border-color: #b87333;
}

.rank-avatar-btn:hover .rank-avatar {
  filter: brightness(0.96);
}

.rank-badge {
  position: absolute;
  right: -2px;
  bottom: -2px;
  z-index: 1;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
  color: #fff;
  background: var(--el-text-color-secondary);
  box-shadow: 0 0 0 1.5px var(--el-bg-color);
}

.rank-avatar-btn.is-gold .rank-badge {
  background: #d4a012;
}

.rank-avatar-btn.is-silver .rank-badge {
  background: #9ca3af;
}

.rank-avatar-btn.is-bronze .rank-badge {
  background: #b87333;
}
</style>
